export const CREATE_PATH_MANUAL = "manual";
export const CREATE_PATH_AI = "ai";
export const CREATE_STAGE_IDLE = "idle";
export const CREATE_STAGE_CREATING_AGENT = "creating_agent";
export const CREATE_STAGE_STARTING_CHAT = "starting_chat";
export const AI_AGENT_DEFAULT_NAME = "New Agent";

export const AI_AGENT_DEFAULT_DESCRIPTION =
  "Self-configuring AI agent created from natural-language requirements.";
export const AI_AGENT_BOOTSTRAP_SYSTEM_PROMPT =
  "You are a self-configuring AI agent. Use your self-configuration tools to inspect and update your settings based on the user's requirements. Make focused configuration changes first, then continue helping the user.";

export function normalizeAiRequirementsInput(value) {
  return String(value || "").trim();
}

export function deriveAiAgentName(requirements) {
  const normalized = normalizeAiRequirementsInput(requirements);
  if (!normalized) return AI_AGENT_DEFAULT_NAME;

  const firstNonEmptyLine =
    normalized.split("\n").find((line) => line.trim().length > 0) || "";
  const sanitized = firstNonEmptyLine
    .replace(/^[-*0-9.)\s]+/, "")
    .replace(/[.,:;!?()[\]{}"'`]/g, "")
    .trim();
  if (!sanitized) return AI_AGENT_DEFAULT_NAME;

  const candidate = sanitized.split(/\s+/).slice(0, 6).join(" ");
  if (!candidate) return AI_AGENT_DEFAULT_NAME;
  return candidate.slice(0, 56).trim();
}

export function buildSelfConfigurationKickoffMessage(requirements) {
  const normalized = normalizeAiRequirementsInput(requirements);
  if (!normalized) return "";

  return [
    "You are configuring your own agent settings based on the user's requirements.",
    "Follow this sequence to ensure an accurate setup:",
    "1) Call get_self_config first to inspect current settings.",
    "2) Review availableToolCatalog from get_self_config and only use those toolName values when setting enabledTools.",
    "3) Determine the smallest set of configuration changes needed.",
    "4) Apply updates with update_self_config only after inspection.",
    "5) Explain exactly what you changed and how it satisfies requirements.",
    "6) If any requirement is ambiguous, ask concise clarifying questions before risky edits.",
    "",
    "User requirements:",
    normalized,
    "",
    "Start by reading your current configuration now.",
  ].join("\n");
}
